import React from 'react';
import {
  BellOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import { Avatar, Badge, Button, Flex, Layout, Dropdown, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import PageRoutes from "../PageRoutes";
import AppMenu from "../menu/index";

const { Header, Sider, Content } = Layout;

const DesktopLayout = ({ viewModel }) => {
  const navigate = useNavigate();
  const {
    collapsed,
    toggleCollapsed,
    user,
    colorBgContainer,
    borderRadiusLG,
    accountMenu,
    notificationUnreadCount,
  } = viewModel;

  return (
    <Layout>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="demo-logo-vertical" />
        <AppMenu variant="desktop"></AppMenu>
      </Sider>
      <Layout>
        <Header style={{ padding: 0, background: colorBgContainer }}>
          <Flex align='center' justify='space-between' style={{ height: '100%' }}>
            <Space align='center'>
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={toggleCollapsed}
                style={{
                  fontSize: '16px',
                  width: 64,
                  height: 64,
                }}
              />
              {user.work_space.name}
            </Space>

            <Space align='center' size={12} style={{ paddingRight: 16 }}>
                <Button
                  type='text'
                  icon={
                    <Badge count={notificationUnreadCount > 99 ? '99+' : notificationUnreadCount} size='small' color='#1677ff' offset={[-2, 2]}>
                      <BellOutlined style={{ fontSize: 20 }} />
                    </Badge>
                  }
                  onClick={() => navigate('/notifications?view=inbox')}
                  style={{ width: 48, height: 48 }}
                  aria-label='Mở thông báo'
                />
                <Dropdown menu={accountMenu}>
                  <Avatar>{user.first_name}</Avatar>
                </Dropdown>
            </Space>
          </Flex>
        </Header>
        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: '100vh',
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <PageRoutes></PageRoutes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default DesktopLayout;
